import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_title_bar = _resolveComponent("title-bar")!
  const _component_tab_pane = _resolveComponent("tab-pane")!
  const _component_media_control = _resolveComponent("media-control")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_title_bar),
    _createVNode(_component_tab_pane, {
      "tab-position": "left",
      mode: "router",
      tabs: _ctx.tabs
    }, null, 8, ["tabs"]),
    _createVNode(_component_media_control)
  ], 64))
}